import { render } from "./PasswordResetter.vue?vue&type=template&id=87c4b21a"
import script from "./PasswordResetter.vue?vue&type=script&lang=js"
export * from "./PasswordResetter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__